import React, { useState, useContext, useEffect } from 'react';
import './LandingPagePopUp.css';
import ROUTES from '../../services/Constants/GlobalRoutes.jsx';
import { useNavigate } from 'react-router-dom';
import VodaPayClubPopupImage from '../../assets/VodaPayClubPopupImage.png';
import DualButtons from '../../components/DualButtons/DualButtons.jsx';
import PropTypes from 'prop-types';
import { UserDetailsContext } from '../../services/context/UserDetailsContext.js';
import { defaultAnalyticsVariables, events, pagePrefix } from '../../services/Constants/Analytics.js';
import useNormalizedSubscriptionStatus from '../../services/utils/subscriptionUtils.js';

/**
 *
 * @param {object} props - the props of the component
 * @param {PropTypes.func} props.onShowPopupChange - function to show the popup
 * @returns {JSX.Element} AdvanceInfo Component
 */
export default function LandingPagePopUp({ onShowPopupChange }) {
  const [showPopup, setShowPopup] = useState(true);
  const navigateTo = useNavigate();
  const userDetails = useContext(UserDetailsContext);
  const subscriptionStatus = useNormalizedSubscriptionStatus();

  const handleClose = () => {
    setShowPopup(false);
    onShowPopupChange(false);
    window.utag?.link({
      ...defaultAnalyticsVariables,
      event_name: [events.interaction],
      page_name: `${pagePrefix}: 50% extra value`,
      link_id: `${pagePrefix}: 50% extra value: close`,
      visitor_addon_type_active: `${defaultAnalyticsVariables.app_name}: subscription: ${subscriptionStatus}`,
    });
  };

  useEffect(() => {
    if (userDetails.userId && userDetails.email && userDetails.msisdn) {
      const userInfo = {
        visitor_id_user: userDetails.userId,
        visitor_id_asset_active: userDetails.msisdn,
        visitor_id_marketing_email: userDetails.email,
      };
      window.utag?.view({
        ...defaultAnalyticsVariables,
        page_name: `${pagePrefix}: 50% extra value`,
        event_name: [events.pageView],
        visitor_addon_type_active: `${defaultAnalyticsVariables.app_name}: subscription: ${subscriptionStatus}`,
        ...userInfo,
      });
    }
  }, [userDetails]);

  const onClickAnalytics = () => {
    window.utag?.link({
      ...defaultAnalyticsVariables,
      event_name: [events.interaction],
      page_name: `${pagePrefix}: 50% extra value`,
      link_id: `${pagePrefix}: 50% extra value: join`,
      visitor_addon_type_active: `${defaultAnalyticsVariables.app_name}: subscription: ${subscriptionStatus}`,
    });
  };

  if (!showPopup) return null;

  if (userDetails.vsp === true) {
    return (
      <div className='popup-container'>
        <div className='popup-content'>
          <img
            src={ VodaPayClubPopupImage }
            alt='Discount Banner'
            className='popup-image'
          />
          <div className='header-text'>
            UP TO 50% EXTRA VALUE
          </div>
          <div className='description'>
            <div className='popup-description'>
              Exclusive deals & vouchers from brands!
            </div>
            <div className='sub-description'>Unlock more value, every time you shop</div>
          </div>
          <div className='popup-button-block'>
            <DualButtons
              primaryOnClick={
                () => {
                  navigateTo(ROUTES.VODAPAY_CLUB);
                  onClickAnalytics();
                }
              }
              secondaryOnClick={ handleClose }
              primaryText={ 'Join the Club' }
              secondaryText={ 'Close' }
            />
          </div>
        </div>
      </div>
    );
  }

  return null;
}

LandingPagePopUp.propTypes = { onShowPopupChange: PropTypes.func };
